import { mergeStyleSets } from '@uifabric/merge-styles';
import { pxToRem } from '../../utils';
import theme from '../../theme.style';

export default mergeStyleSets({
  productId: {
    fontSize: pxToRem(14),
    fontWeight: 'normal',
    color: theme.palette.neutralPrimary,
  },
  productDataContent: {
    fontSize: pxToRem(12),
    fontWeight: 400,
    color: theme.palette.neutralSecondary,
  },
  slash: {
    color: theme.palette.neutralQuaternaryAlt,
  },
  associatedRoyalties: {
    marginBottom: pxToRem(10),
  },
});
